import type { FLAG_VALUES } from '../../../common/hooks/useFeatureFlag';
import type useFeatureFlag from '../../../common/hooks/useFeatureFlag';
export function isFeatureEnabled<T extends FLAG_VALUES>(featureFlag: T, featureFlagResponse: ReturnType<typeof useFeatureFlag<T>>): boolean {
  if (featureFlagResponse.isLoading) {
    return false;
  }
  const featureValue = featureFlagResponse.featureFlags?.[featureFlag];
  if (!featureValue) {
    return false;
  }
  return 'enabled' in featureValue && featureValue.enabled;
}